import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'src/store';

export const breadcrumbsSliceSelector = (state: RootState) => state.breadcrumbs;

export const breadcrumbsNamesMapSelector = createSelector(breadcrumbsSliceSelector, (state) => state.namesMap);
